import { HostType } from "@tdp/common/host";
import { detectHost } from "@tdp/common/host/hostDetection";
import { settingsSlice } from "@tdp/common/settings";

import { StartupFunction } from ".";

export const clientPreferenceStartup: StartupFunction = (root, buildConfig) => {
  const { store, commands } = root;
  let earlyRedirectionUrl: string | undefined = undefined;
  //TODO(nibeauli): clean this up when we have a more structured way of handling settings.
  const baseUrl = (buildConfig.api as { baseUrl: string }).baseUrl;
  if (baseUrl === 'https://dev.teams.microsoft.com/api') {
    earlyRedirectionUrl =
      'https://dev.teams.cloud.microsoft/?client-preference=classic';
  } else {
    earlyRedirectionUrl =
      'https://dev-int.teams.cloud.dev.microsoft/?client-preference=classic';
  }

  const host = detectHost();
  store.dispatch(settingsSlice.actions.setAppRunContext({ host }));
  // TODO: Rollback step 3 -  Line 24  if (host !== HostType.TEAMS && baseUrl !== 'https://dev.teams.microsoft.com/api')) {
  // When rolling back we want to rollback only for Prod so client preference logic should be disabled in PROD like this.
  if (host !== HostType.TEAMS) {
    store.dispatch(commands.clientPreferenceCommands
      .loadUserPreferredClient(earlyRedirectionUrl));
  }
}
